import { HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, throwError, from, map } from 'rxjs';

// 1. 🚀 THE CORRECTED "GATHER AND MERGE" CACHE SCANNER
async function gatherAllCachedEquipments(): Promise<any[]> {
  const cacheNames = await caches.keys();
  let masterEquipmentList: any[] = [];
  const seenIds = new Set<number | string>(); 

  for (const cacheName of cacheNames) {
    const cache = await caches.open(cacheName);
    const cachedRequests = await cache.keys();
    
    for (const req of cachedRequests) {
      
      // ✅ FIX 1: Look for the URLs that were cached when the user clicked a category filter
      // Example: /api/v1/medical_equipments?category_id=1
      if (req.url.includes('/api/v1/medical_equipments') && req.url.includes('category_id=')) {
        
        const response = await cache.match(req);
        if (response) {
          const responseBody = await response.json();
          
          // ✅ FIX 2: Target the data array directly based on your payload
          // Your payload: { success: true, data: [ {id: 60...}, {id: 66...} ] }
          if (responseBody?.success && Array.isArray(responseBody.data)) {
            const equipments = responseBody.data;
            
            for (const item of equipments) {
              // Check for valid ID to prevent duplicates across categories
              if (item && item.id && !seenIds.has(item.id)) {
                seenIds.add(item.id);
                masterEquipmentList.push(item);
              }
            }
          }
        }
      }
    }
  }

  return masterEquipmentList;
}

// 2. 🛡️ THE INTERCEPTOR

// ... (Keep gatherAllCachedEquipments exactly as it is) ...

export const offlineSearchInterceptor: HttpInterceptorFn = (req, next) => {
  
  if (req.url.includes('/api/v1/medical_equipments')) {
    
    const query = req.params.get('search')?.toLowerCase();

    // 🚀 IF IT IS A SEARCH REQUEST...
    if (query) {
      
      // ✅ Inject the 'ngsw-bypass' query parameter.
      // This tells the Service Worker: "Do not intercept this, do not cache this!"
      const bypassedReq = req.clone({
        params: req.params.set('ngsw-bypass', 'true')
      });

      // Pass the bypassed request into next()
      return next(bypassedReq).pipe(
        catchError((error: HttpErrorResponse) => {
          
          // Detect network failure
          if (!navigator.onLine || error.status === 0 || error.status === 504) {
            console.log(`🌐 Offline detected: Running Master List search for "${query}"...`);

            return from(gatherAllCachedEquipments()).pipe(
              map((allData: any[]) => {
                const filteredData = allData.filter((item: any) => {
                  const nameMatch = (item.equipment_name || '').toLowerCase().includes(query);
                  const codeMatch = (item.equipment_code || '').toLowerCase().includes(query);
                  return nameMatch || codeMatch;
                });

                return new HttpResponse({
                  status: 200,
                  body: { success: true, message: "Offline search successful", data: filteredData } 
                });
              })
            );
          }
          return throwError(() => error);
        })
      );
    }
  }

  // Pass through all NON-search requests untouched.
  // Requests like ?category_id=1 or /equipment_id WILL STILL BE CACHED perfectly!
  return next(req);
};